import { Preview } from "@creatomate/preview";
import { Subtitle } from "chq";

const updateSubtitleIndexesInCreatomate = async (
  preview: Preview,
  subtitles: Subtitle[]
): Promise<void> => {
  const activeSubtitle = subtitles.find(subtitle => subtitle.active);
  const modifications = (activeSubtitle?.sections || []).reduce((acc, section) => ({
    ...acc,
    [`${section.creatomateId}.name`]: `sub-${section.index}-${section.creatomateId}`
  }), {});
  await preview.applyModifications(modifications);
};

export default updateSubtitleIndexesInCreatomate;
